/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../add-project/addProject.css";
import { UilCheck, UilImageUpload } from "@iconscout/react-unicons";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";
import { Tooltip } from "react-tooltip";

const AddReview = () => {
  const [title, setTitle] = useState("");
  const [arTitle, setArTitle] = useState("");
  const [name, setName] = useState("");
  const [arName, setArName] = useState("");
  const [description, setDescription] = useState("");
  const [arDescription, setArDescription] = useState("");
  const [image, setImage] = useState(null);
  const [alt, setAlt] = useState("");
  const [arAlt, setArAlt] = useState("");
  const [productId, setProductId] = useState("");
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/dashboard/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await axios.get("/store/products");
        setProducts(Array.isArray(data) ? data : []);
      } catch {
        setProducts([]);
      }
    };
    fetchProducts();
  }, []);

  const handleFileUpload = (file) => {
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setError("");
    } else {
      setError("Please upload a valid image file (png, jpg, jpeg).");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFileUpload(file);
  };

  const handleRemoveImage = () => {
    setImage(null);
  };

  const imageFormats = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "tiff",
    "webp",
    "svg",
    "heic",
    "ico",
    "avif",
  ];

  const handleAddReview = async (e) => {
    e.preventDefault();

    if (
      !title ||
      !arTitle ||
      !name ||
      !arName ||
      !description ||
      !arDescription ||
      !image ||
      !alt ||
      !arAlt
    ) {
      return toast.error("Please fill out all fields.");
    }

    const reviewData = new FormData();
    reviewData.append("title", title);
    reviewData.append("arTitle", arTitle);
    reviewData.append("name", name);
    reviewData.append("arName", arName);
    reviewData.append("description", description);
    reviewData.append("arDescription", arDescription);
    reviewData.append("image", image);
    reviewData.append("alt", alt);
    reviewData.append("arAlt", arAlt);
    if (productId) reviewData.append("productId", productId);

    try {
      setLoading(true);
      const response = await toast.promise(
        axios.post("/reviews", reviewData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          pending: "Adding review...",
          success: "Review added successfully!",
        }
      );

      setTitle("");
      setArTitle("");
      setName("");
      setArName("");
      setDescription("");
      setArDescription("");
      setImage(null);
      setAlt("");
      setArAlt("");
      setProductId("");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="addProject">
        <form className="container" onSubmit={handleAddReview}>
          <div className="title">
            <div className="text">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="35"
                viewBox="0 0 34 35"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.3511 2.271C9.21636 2.271 8.43861 2.271 7.74444 2.45941C7.02601 2.65659 6.35707 3.00266 5.78108 3.47517C5.20509 3.94768 4.73492 4.53605 4.40111 5.20208C4.07952 5.84241 3.92794 6.606 3.70552 7.7195L2.82719 12.1083C2.67164 12.8777 2.68667 13.6718 2.87122 14.4347C3.05577 15.1977 3.40536 15.9109 3.89536 16.5241V20.4128C3.89536 23.0167 3.89536 25.0793 4.11211 26.6929C4.33594 28.3532 4.80627 29.6977 5.86594 30.7587C6.92561 31.8184 8.27003 32.2887 9.93178 32.5126C11.5454 32.7293 13.608 32.7293 16.2104 32.7293H17.7872C20.391 32.7293 22.4537 32.7293 24.0673 32.5126C25.7276 32.2887 27.072 31.8184 28.1331 30.7587C29.1928 29.6977 29.6631 28.3532 29.8869 26.6929C30.1037 25.0779 30.1037 23.0167 30.1037 20.4128V16.5255C30.5937 15.912 30.9431 15.1985 31.1274 14.4353C31.3117 13.6721 31.3264 12.8778 31.1704 12.1083L30.2921 7.7195C30.0711 6.606 29.9181 5.84241 29.5979 5.20208C29.264 4.5359 28.7936 3.94744 28.2173 3.47492C27.6411 3.00241 26.9719 2.65641 26.2532 2.45941C25.5604 2.271 24.7827 2.271 23.6465 2.271H10.3511ZM25.8792 18.5627C26.6002 18.564 27.3142 18.4204 27.9787 18.1405V20.3335C27.9787 23.0351 27.9759 24.9547 27.7804 26.411C27.5891 27.8347 27.2293 28.6564 26.63 29.2557C26.0308 29.8549 25.2091 30.2147 23.7825 30.406C23.0593 30.4948 22.3321 30.5487 21.6037 30.5675V26.6632C21.6037 26.0398 21.6037 25.5015 21.564 25.0623C21.5215 24.5948 21.428 24.133 21.1759 23.6981C20.8964 23.2134 20.4943 22.8108 20.0099 22.5307C19.575 22.28 19.1132 22.1865 18.6457 22.144C18.2065 22.1043 17.6682 22.1043 17.0449 22.1043H16.9528C16.3294 22.1043 15.7925 22.1043 15.3519 22.144C14.8844 22.1865 14.424 22.28 13.9891 22.5307C13.5042 22.8106 13.1016 23.2132 12.8218 23.6981C12.571 24.133 12.4775 24.5948 12.435 25.0609C12.3954 25.5029 12.3954 26.0398 12.3954 26.6617V30.5675C11.666 30.5488 10.9379 30.4949 10.2137 30.406C8.78994 30.2147 7.96828 29.8549 7.36903 29.2557C6.76977 28.6564 6.40994 27.8347 6.21869 26.4096C6.02177 24.9547 6.02036 23.0351 6.02036 20.3335V18.1405C7.15254 18.618 8.41376 18.6949 9.59557 18.3585C10.7774 18.0221 11.809 17.2925 12.52 16.2903C13.034 16.9961 13.708 17.57 14.4866 17.965C15.2653 18.36 16.1264 18.5648 16.9995 18.5627C17.8726 18.5648 18.7338 18.36 19.5124 17.965C20.2911 17.57 20.965 16.9961 21.479 16.2903C21.977 16.9936 22.6366 17.5671 23.4023 17.9625C24.168 18.3579 25.0174 18.5637 25.8792 18.5627ZM14.5204 30.6015C15.07 30.6034 15.6603 30.6043 16.2912 30.6043H17.7079C18.3387 30.6043 18.929 30.6034 19.4787 30.6015V26.7085C19.4787 26.0271 19.4773 25.5865 19.4475 25.2536C19.4192 24.9348 19.3696 24.8187 19.3356 24.7606C19.2425 24.5994 19.1086 24.4656 18.9474 24.3724C18.8894 24.3384 18.7732 24.2902 18.4544 24.2605C17.9701 24.2309 17.4847 24.2205 16.9995 24.2293C16.3181 24.2293 15.8775 24.2293 15.5446 24.2605C15.2244 24.2888 15.1097 24.3384 15.0516 24.3724C14.8899 24.4654 14.7556 24.5992 14.662 24.7606C14.6294 24.8172 14.5799 24.9348 14.5515 25.2536C14.5218 25.5865 14.5204 26.0271 14.5204 26.7085V30.6015ZM12.282 4.396H10.5084C9.15686 4.396 8.68794 4.40591 8.30827 4.50933C7.87729 4.62754 7.47598 4.83505 7.13039 5.11841C6.7848 5.40176 6.50266 5.75462 6.30227 6.15408C6.12519 6.50683 6.02461 6.963 5.75969 8.289L4.91252 12.5248C4.82224 12.9607 4.8218 13.4103 4.91125 13.8463C5.00069 14.2823 5.17814 14.6955 5.43273 15.0606C5.68732 15.4257 6.01371 15.735 6.39193 15.9696C6.77016 16.2042 7.19226 16.3592 7.63244 16.4251C8.07262 16.491 8.52161 16.4664 8.95197 16.3529C9.38232 16.2393 9.78498 16.0391 10.1353 15.7646C10.4857 15.4901 10.7763 15.147 10.9896 14.7563C11.2028 14.3657 11.334 13.9356 11.3754 13.4924L11.4731 12.5206L11.4788 12.4611L12.282 4.396ZM13.5868 12.7189L14.4198 4.396H19.5793L20.4066 12.6722C20.453 13.1457 20.4001 13.6237 20.2515 14.0757C20.1028 14.5277 19.8615 14.9438 19.5431 15.2973C19.2247 15.6509 18.836 15.9342 18.402 16.1292C17.968 16.3242 17.4981 16.4265 17.0223 16.4298C16.5465 16.4331 16.0752 16.3371 15.6386 16.1481C15.2019 15.9591 14.8094 15.6811 14.4862 15.332C14.1629 14.9828 13.916 14.5701 13.7612 14.1202C13.6063 13.6703 13.5469 13.1931 13.5868 12.7189ZM25.6908 4.50933C25.3111 4.40591 24.8422 4.396 23.4907 4.396H21.7142L22.6251 13.491C22.6678 13.9329 22.7999 14.3615 23.0135 14.7506C23.2271 15.1398 23.5177 15.4814 23.8676 15.7547C24.2174 16.028 24.6193 16.2271 25.0486 16.3401C25.4779 16.4531 25.9257 16.4775 26.3648 16.4119C26.8039 16.3462 27.225 16.1919 27.6025 15.9582C27.98 15.7246 28.306 15.4166 28.5606 15.053C28.8152 14.6893 28.9932 14.2776 29.0836 13.843C29.174 13.4084 29.175 12.9599 29.0865 12.5248L28.2408 8.289C27.9744 6.963 27.8739 6.50683 27.6982 6.15408C27.4977 5.75447 27.2153 5.40152 26.8695 5.11816C26.5236 4.8348 26.122 4.62736 25.6908 4.50933Z"
                  fill="black"
                  fill-opacity="0.6"
                />
              </svg>
              <p>Add New Review</p>
            </div>
            <button>
              <UilCheck size={22} />
              Add Review
            </button>
          </div>
          <div className="form">
            <div className="inputs">
              <h3>General information</h3>
              <div className="input">
                <label>
                  Title <span>*</span>
                </label>
                <input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  type="text"
                  placeholder="Give your review a short and clear title."
                />
              </div>
              <div className="input ar-input">
                <label>
                  العنوان <span>*</span>
                </label>
                <input
                  value={arTitle}
                  onChange={(e) => setArTitle(e.target.value)}
                  type="text"
                  placeholder="أعطِ لمراجعتك عنوانًا قصيرًا وواضحًا."
                />
              </div>
              <hr />
              <div className="input">
                <label>Product (optional)</label>
                <select
                  value={productId}
                  onChange={(e) => setProductId(e.target.value)}
                >
                  <option value="">— No product —</option>
                  {products.map((p) => (
                    <option key={p._id} value={p._id}>
                      {p.name} — {p.price} SAR
                    </option>
                  ))}
                </select>
              </div>
              <hr />
              <div className="input">
                <label>
                  Name <span>*</span>
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Write the name of reviewer."
                />
              </div>
              <div className="input ar-input">
                <label>
                  الاسم <span>*</span>
                </label>
                <input
                  value={arName}
                  onChange={(e) => setArName(e.target.value)}
                  type="text"
                  placeholder="اكتب اسم المراجع."
                />
              </div>
              <hr />
              <div className="input textarea">
                <label>
                  Description <span>*</span>
                </label>
                <textarea
                  placeholder="Write the review content."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
              <div className="input textarea ar-input">
                <label>
                  الوصف <span>*</span>
                </label>
                <textarea
                  placeholder="اكتب محتوى المراجعة."
                  value={arDescription}
                  onChange={(e) => setArDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="image">
              <h3>Upload image</h3>

              {image ? (
                <div className="imgPreview">
                  <img src={URL.createObjectURL(image)} alt="Uploaded" />
                  <button className="remove-btn" onClick={handleRemoveImage}>
                    <i className="uil uil-times"></i>
                  </button>
                </div>
              ) : (
                <div
                  className="imgInput"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={handleDrop}
                >
                  <UilImageUpload size={40} />
                  <p>Drop your main image here, or</p>
                  <div className="btn">
                    <button type="button">Click here</button>
                    <input
                      type="file"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      accept="image/*"
                    />
                  </div>
                </div>
              )}

              {error && <p className="error">{error}</p>}

              {!image && (
                <>
                  <div className="image-p">
                    <p className="inf" id="inf">
                      Upload your review image.
                    </p>
                    <i className="uil uil-info-circle" id="formats"></i>
                  </div>
                  <Tooltip
                    anchorSelect="#formats"
                    content={imageFormats.join(", ")}
                    place="top"
                  />
                </>
              )}

              <div className="input">
                <label>
                  Image alt <span>*</span>
                </label>
                <input
                  value={alt}
                  onChange={(e) => setAlt(e.target.value)}
                  type="text"
                  placeholder="Give your review image a short alt text."
                />
              </div>
              <div className="input ar-input">
                <label>
                  النص البديل للصورة <span>*</span>
                </label>
                <input
                  value={arAlt}
                  onChange={(e) => setArAlt(e.target.value)}
                  type="text"
                  placeholder="أضف نصًا بديلًا قصيرًا إلى صورة المراجعة الخاصة بك."
                />
              </div>
            </div>
          </div>
        </form>
      </main>
    </>
  );
};

export default AddReview;
